<template>
  <v-data-table
    height="55vh"
    fixed-header
    :headers="headers"
    :items="this.$store.state.users"
    :search="search"
    sort-by="rowId"
    class="elevation-1"
  >
    <template v-slot:top>
      <div class="pa-5">
        <div class="row viewList">
          <div class="col-sm-12 col-md-4 col-lg-4">
            <v-select
              v-model="select"
              :items="$store.state.userCmb"
              item-text="name"
              label="Select"
              persistent-hint
              single-line
              return-object
            ></v-select>
            <!-- <v-select :items="items" v-model="select" label="查詢條件" dense outlined ></v-select> -->
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4">
            <v-text-field
              v-model="queryCon"
              v-bind:label="select.placeholder"
              single-line
              hide-details
            ></v-text-field>
          </div>
          <div class="col-sm-12 col-md-2 col-lg-1">
            <v-btn
              large
              color="primary"
              dark
              class="mb-2"
              aria-setsize="16px"
              block
              @click="query"
              >查詢</v-btn
            >
          </div>
          <div class="col-sm-12 col-md-2 col-lg-1">
            <v-spacer></v-spacer>
            <!-- 新增 編輯 功能預留
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn
                  large
                  color="primary"
                  dark
                  class="mb-2"
                  aria-setsize="16px"
                  v-on="on"
                  block
                  >新增</v-btn
                >
              </template>

              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.userId"
                            label="使用者代碼"
                            :disabled="disabled"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.userName"
                            label="使用者名稱"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-select
                            v-model="editedItem.group"
                            :items="$store.state.userGroup"
                            item-text="name"
                            item-value="value"
                            label="使用者群組"
                            dense
                            return-object
                            outlined
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.userEmail"
                            label="信箱"
                            :rules="emailRules"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.userTel"
                            label="電話"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                          <v-select
                            v-model="editedItem.status"
                            :items="$store.state.useStatus"
                            item-text="name"
                            item-value="value"
                            label="使用狀態"
                            dense
                            return-object
                            outlined
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">取消</v-btn>
                  <v-btn color="blue darken-1" text @click="validate" :disabled="!valid"
                    >儲存</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
             -->
          </div>
        </div>
      </div>
    </template>
    <!-- 編輯 刪除 功能預留
    <template v-slot:item.actions="{ item }">
      <v-btn
        class="mx-2"
        depressed
        fab
        dark
        small
        color="primary"
        @click="editItem(item)"
      >
        <v-icon dark>mdi-pencil</v-icon>
      </v-btn>
      <v-btn
        class="mx-2"
        depressed
        fab
        dark
        small
        color="grey lighten-1"
        @click="deleteItem(item)"
      >
        <v-icon dark>mdi-delete</v-icon>
      </v-btn>
    </template>
     -->
    <template v-slot:no-data>查無資料</template>
  </v-data-table>
</template>
<script>
export default {
  data: () => ({
    //valid: true,
    search: '',
    //dialog: false,
    //disabled: false,
    queryCon: '',
    select: { name: '請選擇', value: null },
    //selectG: { name: '請選擇', value: '' },
    headers: [
      { text: '使用者代碼', value: 'userId' },
      { text: '使用者名稱', value: 'userName' },
      { text: '使用者群組', value: 'groupName' },
      { text: '信箱', value: 'userEmail' },
      { text: '電話', value: 'userTel' },
      { text: '是否使用', value: 'status.name' },
      {
        text: '備註',
        align: 'start',
        sortable: false,
        value: 'memo'
      },
      { text: '', value: 'actions', sortable: false }
    ],
    userData: [],
    /*
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
    ],
    */
    editedIndex: -1,
    editedItem: {},
    defaultItem: {}
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? '新增使用者' : '使用者維護'
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.initialize()
  },

  methods: {
    initialize() {},
    query() {
      let url = this.$store.state.api + '/S00050/QueryUser'
      let data = Object.assign(
        { queryType: this.select.value },
        { queryCon: this.queryCon }
      )
      window.console.log(data)
      this.axios.post(url, this.qs.stringify(data)).then(res => {
        //先把store舊的清掉
        this.$store.state.users.splice(0)
        if (res.data.resultCode == '10') {
          var rows = res.data.rows
          for (var i = 0; i < res.data.rows.length; i++) {
            var row = rows[i]
            row.status = {
              name: row.statusName,
              value: row.statusId
            }
            row.group = {
              name: row.groupName,
              value: row.groupId
            }
            this.$store.state.users.push(row)
            window.console.log(row)
          }
        } else {
          alert(res.data.error)
        }
      })
    },
    editItem(item) {
      this.disabled = true
      this.editedIndex = this.$store.state.users.indexOf(item)
      this.editedItem = Object.assign({}, item)
      //this.$store.state.users = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item) {
      const index = this.$store.state.users.indexOf(item)
      confirm('確認是否刪除此帳號?') && this.$store.state.users.splice(index, 1)
    },

    close() {
      this.disabled = false
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    validate() {
      this.$refs.form.validate()

      if (this.editedIndex > -1) {
        //修改
        let url = this.$store.state.api + '/S00050/ActUser'
        let data = Object.assign(
          { sysUserId: this.editedItem.sysUserId },
          { userId: this.editedItem.userId },
          { userName: this.editedItem.userName },
          { userGroup: this.editedItem.group.value },
          { statusId: this.editedItem.status.value },
          { userEmail: this.editedItem.userEmail },
          { userTel: this.editedItem.userTel }
        )

        return
        this.axios.post(url, this.qs.stringify(data)).then(res => {
          if (res.data.resultCode == '10') {
            Object.assign(this.$store.state.users[this.editedIndex], this.editedItem)
            this.query()
          } else {
            alert(res.data.error)
          }
        })
      } else {
        //this.userData.push(this.editedItem)
        this.$store.state.users.push(this.editedItem)
      }
      this.close()
    }
  }
}
</script>
